import { normalizeName } from '@core/utils/normalize-name';
import type {
    MemberEditionInput,
    MemberId,
    MemberLight,
    MemberSummary,
} from '@wwf/sdk';
import { RAFile } from './types';

export function getFullName(
    member: MemberLight | MemberSummary | MemberInput | undefined
): string {
    if (!member) return '';
    return normalizeName(
        `${member.firstName ?? ''} ${member.lastName ?? ''}`.trim()
    );
}

export type MemberInput = MemberEditionInput & {
    id: MemberId;
    avatarInput?: RAFile;
};

export function memberSummaryToInput(summary: MemberSummary): MemberInput {
    const {
        avatar,
        createdAt,
        updatedAt,
        organizationId,
        lastSeen,
        status,
        tags,
        antennas,
        nbMissions,
        nbNotes,
        ...edition
    } = summary;

    const antennaIds = antennas?.map(a => a.id) ?? [];

    return {
        ...edition,
        avatarId: avatar?.id ?? null,
        antennaIds,
    };
}
